"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var admin_1 = require("services/page/admin");
var common_1 = require("../../../services/page/common");
var lang_1 = require("../../../utils/lang");
var banner_1 = require("utils/playground/banner");
var Carousel_1 = require("../../components/Carousel");
var CountBanner_1 = require("../../components/CountBanner");
var MagicBanner_1 = require("../../components/MagicBanner");
var NavBar_1 = require("../../components/NavBar");
var Products_1 = require("../../components/Products");
var TextBanner_1 = require("../../components/TextBanner");
var Coupon_1 = require("../../components/Coupon");
var styles = require("./index.scss");
var CardBanner_1 = require("../../components/CardBanner");
var banner_2 = require("../../utils/banner");
var Main = (function (_super) {
    __extends(Main, _super);
    function Main(props) {
        var _this = _super.call(this, props) || this;
        _this.renderComponents = function (item, index) {
            var positionIndex = index + 1;
            var commonProps = {
                key: index + 1,
                positionIndex: positionIndex,
                id: item.header.position ? item.header.position : "floor" + (index + 1)
            };
            switch (item.type) {
                case admin_1.TModuleType.TNavIcons:
                    var navs = item.module.icons;
                    var NavBarWithPrm = NavBar_1.default({ positionIndex: positionIndex });
                    return (React.createElement(NavBarWithPrm, __assign({ stickToTop: _this.props.stickToTop, navModules: navs }, commonProps)));
                case admin_1.TModuleType.TSwiper:
                    if (item.layout && item.layout.interaction !== common_1.ModuleInteraction.None) {
                        var banners = banner_2.transformCardBanner(item.module.elements);
                        var CardBannerWithPrm = CardBanner_1.default({ positionIndex: positionIndex });
                        return React.createElement(CardBannerWithPrm, __assign({}, commonProps, { cardBanners: banners }));
                    }
                    else {
                        var banners = banner_2.transCarouselBanner(item.module.elements);
                        var CarouselWithPrm = Carousel_1.default({ positionIndex: positionIndex });
                        return (React.createElement(CarouselWithPrm, __assign({}, commonProps, { showArrow: true, style: { width: "100%", height: "100%" }, banners: banners })));
                    }
                case admin_1.TModuleType.TMagicBannerType:
                case admin_1.TModuleType.TMagicBannerTwo:
                    var magicModule = item.module;
                    if (!magicModule.banners && !magicModule.banner) {
                        return;
                    }
                    var singleBanner = item.type === admin_1.TModuleType.TMagicBannerType ? magicModule.banner : magicModule.banners[0];
                    var magicItems = magicModule.items;
                    var MagicBannerWithPrm = MagicBanner_1.default({ positionIndex: positionIndex });
                    return (React.createElement(MagicBannerWithPrm, __assign({}, commonProps, { banner: singleBanner, magicItems: magicItems, stickToTop: _this.props.stickToTop })));
                case admin_1.TModuleType.TRichText:
                    var textModule = item.module;
                    return (React.createElement(TextBanner_1.default, __assign({}, commonProps, { customUI: item.ui, content: textModule && textModule.content })));
                case admin_1.TModuleType.TCountdownBanner:
                    var countDownModule = item.module;
                    return (React.createElement(CountBanner_1.default, __assign({}, commonProps, { customUi: item.ui, moduleId: item.id, banner: banner_2.transformBanner(countDownModule.banner), timer: countDownModule.timer, state: countDownModule.state })));
                case admin_1.TModuleType.TMultiProductModuleType:
                    var productModule = item.module;
                    if (!productModule.proModules || productModule.proModules.length === 0) {
                        return;
                    }
                    var ProductsWithPrm = Products_1.default({ positionIndex: positionIndex });
                    return (React.createElement(ProductsWithPrm, __assign({}, commonProps, { pools: productModule.proModules, customUI: item.ui, layout: item.layout, columnSize: item.layout.columnNum, stickToTop: _this.props.stickToTop })));
                case admin_1.TModuleType.TCoupon:
                    var _a = banner_2.transformCouponInfo(item), coupons = _a.coupons, columnSize = _a.columnSize;
                    var couponProps = __assign(__assign({}, commonProps), { coupons: coupons,
                        columnSize: columnSize });
                    var CouponWithPrm = Coupon_1.default({ positionIndex: positionIndex });
                    return React.createElement(CouponWithPrm, __assign({}, couponProps));
                default:
                    return null;
            }
        };
        _this.state = {};
        return _this;
    }
    Main.prototype.render = function () {
        var _this = this;
        var _a = this.props.store, frontModules = _a.frontModules, backgroundColor = _a.backgroundColor, isPageDisable = _a.isPageDisable;
        if (isPageDisable) {
            var getLang = lang_1.getLitbLangFn();
            return (React.createElement("div", { className: styles.errorPage },
                React.createElement("img", { src: banner_1.GetErrorImage(), alt: "" }),
                React.createElement("p", null, getLang("error_message")),
                React.createElement("a", { href: location.origin }, getLang("go_shopping"))));
        }
        console.log("此为新的资源路径");
        var dataSource = mobx_1.toJS(frontModules);
        return (React.createElement("div", { className: styles.container, style: { backgroundColor: backgroundColor }, "data-bg": backgroundColor }, dataSource.length === 0 ? (React.createElement("img", { className: styles.placeholder, src: banner_1.GetEmptyImage(), alt: "" })) : (dataSource.map(function (item, index) {
            return _this.renderComponents(item, index);
        }))));
    };
    Main = __decorate([
        mobx_react_1.observer
    ], Main);
    return Main;
}(React.Component));
exports.default = Main;
